import { render, staticRenderFns } from "./dailypackage.vue?vue&type=template&id=cf9817a6&scoped=true"
import script from "./dailypackage.vue?vue&type=script&lang=ts"
export * from "./dailypackage.vue?vue&type=script&lang=ts"
import style0 from "./dailypackage.vue?vue&type=style&index=0&id=cf9817a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9817a6",
  null
  
)

export default component.exports